import { useInfiniteQuery } from 'react-query';
import axios from 'axios';

const fetchItems = async ({ pageParam = 1, queryKey }) => {
  const [_key, searchQuery] = queryKey;
  let backendUrl = process.env.REACT_APP_BACKEND_API;
  const { data } = await axios.post(`${backendUrl}api/v1/business/getAllRestaurants`, {
    page: pageParam,
    pageSize: 12,
    search: searchQuery
  });
  return data;
};

export const useItems = (searchQuery) => {
  return useInfiniteQuery(
    ['items', searchQuery],
    fetchItems,
    {
      getNextPageParam: (lastPage, pages) => {
        let lastPageData = lastPage?.data;
        return (
          lastPageData.hasMore ? lastPageData?.page + 1 : undefined
        )
      }
    }
  );
};
